import React, { useEffect } from 'react';
import TopBar from '../../Components/TopBar';
import Footer from '../../Components/Footer';
import { pageView } from '../../Utilities/GoogleAnalytics';
const InstagramIcon = 'https://res.cloudinary.com/stamped/image/upload/v1608735325/SVGs/instagram_yywm4e.svg';
const MailIcon = 'https://res.cloudinary.com/stamped/image/upload/v1608735327/SVGs/mail_k5ikwu.svg';

export default function Contact() {
  //On load, let us punch some pageview
  useEffect(() => {
    pageView(window.location.pathname);
    window.scroll(0, 0);
  }, []);

  const TitleSection = () => {
    return (
      <>
        <div className="flex flex-col-reverse items-center h-auto pt-12 cursor-pointer bg-altBack lg:flex-row lg:pt-32">
          <div className="w-full text-center md:p-6 lg:p-0">
            <div className="w-full p-6 m-auto my-6 shadow-sm md:p-16 lg:p-24 lg:w-10/12">
              <h1 className="my-6 text-3xl font-bold text-brandcolor font-brand lg:text-5xl">Get in touch. Join the community.</h1>
              <div className="justify-center lg:flex">
                <a target="_blank" rel="noreferrer" href="https://www.instagram.com/stamped.wiki/">
                  <LargeCard
                    icon={InstagramIcon}
                    heading="stamped.wiki"
                    description="Follow us on Instagram for important updates from Canada, interesting facts & exclusive community insights."
                  />
                </a>
                <a target="_blank" rel="noreferrer" href="mailto:support@stamped.wiki">
                  <LargeCard
                    icon={MailIcon}
                    heading="support e-mail"
                    description="For affiliate inquiries, questions about the product or anything in general:  send us an e-mail on support@stamped.wiki"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const LargeCard = ({ icon, heading, description, subtitle, rotateH }) => (
    <div className="p-10 m-2 text-center transition-all duration-300 bg-white shadow-sm lg:max-w-md hover:shadow-md">
      <div className="flex flex-row items-center justify-center my-4 space-x-2">
        <img src={icon} className="w-5 h-5" alt="Icon" />
        <h1 className="text-xl font-bold">{heading}</h1>
      </div>
      <p className="mt-2 text-sm"> {description}</p>
      <p className="mt-6 text-xs text-gray-500 uppercase"> {subtitle} </p>
    </div>
  );

  return (
    <div className="min-h-screen bg-altBack">
      <TopBar />
      <TitleSection />
      <Footer />
    </div>
  );
}
